import React, { FC } from 'react';
import DeactivateOrchestrator from '../../components/Deactivate';

interface DeactivateAccountProps {
  isWebview?: boolean;
  useFlexFlow?: boolean;
}

const DeactivateAccount: FC<DeactivateAccountProps> = ({ isWebview = false, useFlexFlow = false }) => (
  <DeactivateOrchestrator isWebview={isWebview} useFlexFlow={useFlexFlow} />
);

export default DeactivateAccount;

